import { Link } from 'react-router-dom';

export function NotFoundPage(): JSX.Element {
  return (
    <main className="grid min-h-screen place-items-center bg-onyx-900 px-6 text-center">
      <div>
        <p className="font-display text-7xl text-aurum-500">٤٠٤</p>
        <p className="mt-4 font-body text-cream-100/80">
          هذه الصفحة لم تُحضّر بعد.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block text-sm uppercase tracking-widest text-aurum-300 hover:text-aurum-200"
        >
          العودة إلى الواجهة
        </Link>
      </div>
    </main>
  );
}
